<template>
    <div>
        <a-page-header
            style="border: 1px solid rgb(235, 237, 240)"
            :ghost="false"
            title="Report"
            :sub-title="title"
            @back="back">

            <common-training-header :withLocation="true"/>
        </a-page-header>

        <a-row style="margin-bottom: 20px;">
            <a-col class="text-right">
                <download-excel :data="excel" name="training-scores-ranking.xls">
                    <a-button :loading="loading" type="primary">Download <a-icon type="cloud-download" /> </a-button>
                </download-excel>
            </a-col>
        </a-row>

        <a-card type="inner" size="small">
            <a-skeleton :loading="loading" active>
                <a-table class="pcp-table" :dataSource="items.user_scores" rowKey="hash" :pagination="false" bordered>

                    <a-table-column :width="50" key="number" title="No" className="align-center text-small text-left">
                        <h3 slot-scope="t,r,i" class="text-center">
                            {{ i + 1 }}
                        </h3>
                    </a-table-column>

                    <a-table-column :width="100" key="photo" title="Foto" className="align-center text-small text-left">
                        <template slot-scope="record">
                            <div style="text-align: center">
                                <img :src="record.photo" v-if="record.photo != null" height="50" />
                                <a-avatar class="avatar" size="large" shape="circle" v-else>{{ initial(record.name) }}</a-avatar>
                            </div>
                        </template>
                    </a-table-column>

                    <a-table-column key="attendant" title="Nama" className="align-center text-small">
                        <template slot-scope="record">'
                            <h3>
                                <a-icon type="user" /> {{ record.name }} <br>
                                <a-icon type="mail" /> {{ record.email }}
                            </h3>
                        </template>
                    </a-table-column>

                    <a-table-column :width="350" key="position" title="Posisi / Asal" className="align-center text-small text-left">
                        <template slot-scope="record">
                            <h3>{{ record.position }}</h3>
                        </template>
                    </a-table-column>

                    <a-table-column key="name" title="Penempatan" className="align-center text-small text-left" width="40%">
                        <template slot-scope="record">
                            <h3>{{ record.members[0].branch.name }}</h3>
                        </template>
                    </a-table-column>

                    <a-table-column-group>
                        <span slot="title" class=align-center">Nilai</span>

                        <a-table-column key="total_header" title="Nilai Akhir" className="align-center text-center">
                            <template slot-scope="record">
                                <h3 v-if="record.module_scores.length > 0">
                                    {{ parseFloat(record.module_scores[0].paper_score).toFixed(2) }}
                                </h3>
                                <h3 v-else>{{ record.members[0].pcp_score }}</h3>
                            </template>
                        </a-table-column>
                    </a-table-column-group>
                </a-table>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
export default {
    props: {
        module: {
            type: String,
            default: 'paper'
        }
    },
    data() {
        return {
            loading: false,
            items: {
                user_scores: []
            }
        }
    },
    computed: {
        title(){
            switch(this.module) {
                case "training":
                    return "Penilaian Seluruh Nilai Berdasarkan Nilai Tertinggi"
                case "evaluation":
                    return "Rekap Evaluasi Kinerja Berdasarkan Nilai Tertinggi"
                case "project":
                    return "Rekap Penilaian Project Management Berdasarkan Nilai Tertinggi"
                default:
                    return "Rekap Nilai Makalah Berdasarkan Nilai Tertinggi"
            }
        },
        excel() {
            let excel = []

            if (this.loading)
                return excel

            this.items.user_scores.forEach(function (i) {
                excel.push({
                    name: i.name,
                    position: i.position,
                    total: i.hasOwnProperty('module_scores') && i.module_scores.length > 0 ? parseFloat(i.module_scores[0].paper_score).toFixed(2) : parseFloat(i.members[0].pcp_score).toFixed(2)
                })
            })

            return excel
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true
            let uri = this.routeUri('api.report.paper.highest_score')

            switch (this.module) {
                case 'training':
                    uri = this.routeUri('api.report.pcp.highest')
                    break;
                case 'evaluation':
                    uri = this.routeUri('api.report.evaluation.highest_score')
                    break;
                case 'project':
                    uri = this.routeUri('api.report.project.highest_score')
                    break;
                default:
                    uri = this.routeUri('api.report.paper.highest_score')
                    break;
            }

            this.$http.get(uri)
                .then(response => {this.items = response.data})
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        back() {
            window.location.href = this.routeUri('admin.classical.general.report')
        }
    },
}
</script>
